import React, { ReactElement } from 'react';
import { Badge, Label } from '@nooz-optics/nooz-components-lib';
import { Image } from '../../UI/Media';
import { returnFormatedDate } from '../../../utils/globals';
import { BlogBody } from '../../UI/Elements/Body/Blog/blogBody';

export const BlogPost = ({ article }): ReactElement => {
  const { author, body, image, label, subLabel, createdAt, categories } =
    article;

  const articleSubLabel = `${returnFormatedDate(createdAt)} | ${author?.name}`;

  return (
    <>
      <div className='flex flex-col justify-center w-full sm:w-11/12 h-52 sm:h-64 md:h-72 lg:h-96 overflow-hidden'>
        <div className='w-full h-full'>
          <Image
            {...image}
            width='100%'
            height='100%'
            objectFit='cover'
            objectPlacement='center'
          />
        </div>
      </div>
      <div className='w-full sm:w-11/12 border-b-2  py-12'>
        <div className='flex mb-2'>
          {categories?.map((category) => (
            <div className='mr-2'>
              <Badge
                size='sm'
                type='white'
                dotColor={category?.color}
                label={category.label}
              />
            </div>
          ))}
        </div>
        <Label
          type='h1'
          size='6xl'
          weight='medium'
          lineHeight='snug'
          text={label?.text}
          color={{ classname: 'gray-800' }}
        />
        {subLabel && (
          <div className='pt-4'>
            <Label
              size='lg'
              text={subLabel.text}
            />
          </div>
        )}
        <div className='pt-3'>
          <Label
            size='sm'
            text={articleSubLabel}
          />
        </div>
      </div>
      <div className='w-full sm:w-3/4 py-14'>
        <BlogBody richBody={body} />
      </div>
    </>
  );
};
